<template lang="html">
  <div ref="editor"></div>
</template>

<script>
import E from 'wangeditor'
import Config from '@/framework/configs/Config'
export default {
  name: 'wang-edit',
  data: function () {
    return {
      options: {
        uploadImgServer: 'http://www.baidu.com',
        uploadImgParams: {
          folderName: 'activityImages'
        },
        menus: [
          'fontSize',
          'bold',
          'underline',
          'link',
          'foreColor',
          'justify',
          'image',
          'justify', // 对齐方式
          'foreColor', // 文字颜色
          'list', // 列表
          'quote', // 引用
          'emoticon', // 表情
          'undo', // 撤销
          'redo', // 重复
          'table' // 表格
        ]
      }
    }
  },
  mounted: function () {
    let editorRef = this.$refs.editor
    var editor = new E(editorRef)
    editor.customConfig.menus = [
      'head',
      'bold',
      'italic',
      'underline',
      'image',
      'justify', // 对齐方式
      'foreColor', // 文字颜色
      'undo', // 撤销
      'redo' // 重复
    ]

    // 图片上传配置
    let url = null
    if (window.location.hostname == 'localhost') {
      url = Config.baseUrl + 'upload/uploadPic'
    } else {
      url = Config.baseUrl + 'upload/uploadPic'
    }

    editor.customConfig.uploadImgServer = url
    editor.customConfig.zIndex = 100
    editor.customConfig.pasteFilterStyle = false
    editor.customConfig.uploadFileName = 'file'
    // editor.customConfig.uploadImgMaxLength = 1

    editor.customConfig.uploadImgParams = {
      floder: 'carExhibition'
    }

    editor.customConfig.uploadImgHooks = {
      customInsert: function (insertImg, result, editor) {
        var url = result.datas
        insertImg(Config.imageUrl + url)
      }
    }

    // 改变事件
    editor.customConfig.onchange = (html) => {
      this.$emit('change', html)
    }
    editor.create()

    this.editor = editor

    let wETextContainer = editorRef.getElementsByClassName('w-e-text-container')

    let clientHeight = document.body.clientHeight
    let y = editorRef.offsetTop
    let dom = wETextContainer[0]
    dom.style.height = clientHeight - y - 300 + 'px'
  },
  methods: {
    setContent: function (html) {
      this.editor.txt.html(html)
    }
  }
}
</script>

<style lang="css">
</style>
